// extracted by mini-css-extract-plugin
export default {"container":"BackButton_container__qYWUV","btn":"BackButton_btn__wJPAZ","btnLabel":"BackButton_btnLabel__nGuL+"};